import { GraphQLClient } from "graphql-request";
import { API_GRAPQL } from "./variables";
import {
  GET_ALL_POSTS_GQL,
  GET_POSTS_CARDS_GQL,
} from "../components/jsons/grapql";
import api from "../services/api";

const client = new GraphQLClient(API_GRAPQL);

export const request = {
  async query(query, variables) {
    return client.request(query, variables);
  },
};

export class NewsService {
  static async getPostsCard(input) {
    const dataGQL = await request.query(GET_POSTS_CARDS_GQL, {
      first: input.first,
    });

    const arrayOfNews = dataGQL.posts.nodes;

    const nodesWithImages = await Promise.all(
      arrayOfNews.map(async (item) => {
        const { data } = await api.get(`image_capa/${item.slug}`);

        return {
          ...item,
          oldImage: data.res?.[0]?.img ?? undefined,
        };
      })
    );

    return nodesWithImages;
  }

  static async getAllPostsCard() {
    const dataGQL = await request.query(GET_ALL_POSTS_GQL, {});
    const arrayOfNews = dataGQL.posts.nodes;

    const nodesWithImages = await Promise.all(
      arrayOfNews.map(async (item) => {
        const { data } = await api.get(`image_capa/${item.slug}`);

        return {
          ...item,
          oldImage: data.res?.[0]?.img ?? undefined,
        };
      })
    );
    return nodesWithImages;
  }
}
